import { forwardRef, memo } from "react"
import { PlayerInfo } from "./PlayerInfo"
import { CardHand } from "./CardHand"


/**
 * TrickWinsIndicator
 *
 * Renders three small dots (one per trick slot) beside the player avatar:
 *   ● green  = win
 *   ● red    = lose
 *   ● grey   = draw
 *   ○ empty  = trick not yet played (null)
 */
function TrickWinsIndicator({ trickWins = [null, null, null], pointsX, pointsY, newClassName = "", points = 0 }) {
  return (
    <div className={`player-trick-win-notation ${newClassName}`} style={{ top: pointsY, left: pointsX }}>
      <div className={`handWinIndicatorDiv`}>
        {trickWins.map((result, i) => {
          let cls = "handWinIndicator"
          if (result === "win") cls += " indicateWin"
          if (result === "lose") cls += " indicateLose"
          if (result === "draw") cls += " indicateDraw"
          return <span key={i} className={cls} />
        })}
      </div>
      <p className="truco-current-playing-points">{points}</p>
    </div>
  )
}


/**
 * Seat
 *
 * symmetricOpponents — when true and this seat is NOT the local player's seat,
 * a scaleX(-1) transform is applied to the seat's root element.  This mirrors
 * the opponent visually so the table looks symmetric from the local player's
 * perspective.  The flag is configurable at runtime via SET_SYMMETRIC_OPPONENTS.
 *
 * trickWins — array of 3 entries (one per trick slot), each being:
 *   "win" | "lose" | "draw" | null (not yet played)
 * Forwarded to PlayerInfo for display.
 */
export const Seat = memo(forwardRef(
  ({
    name, cards, seatClass, x, y, totalSeats,
    getCardPosition, getCenterCardPos, seatIndex,
    isMe = false, isMyTurn, clearActionButtons, isCardsDealing,
    sendPlayerAction, seatNumber, dispatch, points,
    trickWins = [null, null, null], pointsX, pointsY,
    symmetricOpponents = true, remaining, duration, showTimer
  }, ref) => {

    // Mirror non-local seats when symmetricOpponents is enabled
    const mirrorStyle = symmetricOpponents && !isMe
      ? { transform: "scaleX(-1)" }
      : undefined

    return (
      <div id={`seat-${seatIndex}`} ref={ref} className={`truco-seat ${seatClass}`}>
        <CardHand
          cards={cards}
          getCardPosition={getCardPosition}
          getCenterCardPos={getCenterCardPos}
          totalSeats={totalSeats}
          seatIndex={seatIndex}
          seatNumber={seatNumber}
          isMe={isMe}
          isMyTurn={isMyTurn}
          isCardsDealing={isCardsDealing}
          clearActionButtons={clearActionButtons}
          sendPlayerAction={sendPlayerAction}
          dispatch={dispatch}
        />
        <PlayerInfo
          name={name}
          seatIndex={seatIndex}
          x={x}
          y={y}
          remaining={remaining}
          duration={duration}
          showTimer={showTimer}
          // isMirrored={symmetricOpponents && !isMe}
          isMirrored={symmetricOpponents && !isMe && seatIndex / totalSeats > 0 && seatIndex / totalSeats < 0.5}
        />
        {Boolean(cards.length) && <TrickWinsIndicator
          points={points}
          pointsX={pointsX}
          pointsY={pointsY}
          newClassName={seatIndex === 0 ? "non-player-truco-points" : "player-truco-points"}
          trickWins={trickWins} />}
      </div>
    )
  }
))